import { useState } from "react";
import {
  Select,
  MenuItem,
  TextField,
  Button,
  Grid,
  Typography,
  Box,
} from "@mui/material";

const IglBooking = () => {
  const [provider, setProvider] = useState("");
  const [bpNo, setBpNo] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [bankIfsc, setBankIfsc] = useState("");
  const [amount, setAmount] = useState("");

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#e0f0f1",
        border: "2px solid rgb(252, 216, 162)",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6} lg={5}>
          <Box
            sx={{
              p: 4,
              borderRadius: 4,
              bgcolor: "white",
              textAlign: "center",
            }}
          >
            <Typography variant="h5" gutterBottom fontWeight={600} color="#00796b">
              IGL COMMERCIAL BILL PAYMENT
            </Typography>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Typography variant="subtitle1" fontWeight={500} color="#00796b">
                  Select Provider
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Select
                  fullWidth
                  value={provider}
                  onChange={(e) => setProvider(e.target.value)}
                  displayEmpty
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Select your provider
                  </MenuItem>
                  <MenuItem value="IGL">IGL Commercial Bill</MenuItem>
                </Select>
              </Grid>

              {provider && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Enter BP No (Business Partner No)"
                      variant="outlined"
                      value={bpNo}
                      onChange={(e) => setBpNo(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Party Beneficiary Name"
                      variant="outlined"
                      value="Indraprastha Gas Ltd."
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Enter Bank A/c No*"
                      variant="outlined"
                      value={bankAccount}
                      onChange={(e) => setBankAccount(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Enter Bank IFSC*"
                      variant="outlined"
                      value={bankIfsc}
                      onChange={(e) => setBankIfsc(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12} textAlign="center">
                    <TextField
                      fullWidth
                      label="Amount"
                      variant="outlined"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} textAlign="center">
                    <Button
                      variant="contained"
                      sx={{
                        mt: 2,
                        py: 1.5,
                        fontSize: "1rem",
                        fontWeight: 600,
                        bgcolor: "#00796b",
                        "&:hover": { bgcolor: "#004d40" },
                      }}
                      disabled={!amount}
                    >
                      Pay Now
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default IglBooking;